class FaqTabs extends HTMLElement {
  connectedCallback() {
    this.tablist = this.querySelector('.faq-tabs__list');
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.panels = [...this.querySelectorAll('[role="tabpanel"]')];

    if (this.tablist && this.tabs.length > 1) {
      this.tabs.forEach((tab) => this.tablist.append(tab));
      this.tablist.hidden = false;
    } else {
      this.tabs.forEach((tab) => {
        tab.hidden = true;
      });
    }

    if (this.tabs.length === 0) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.select(tab));
      tab.addEventListener('keydown', (event) => this.onKeydown(event));
    });

    this.section = this.closest('.shopify-section');
    this.onBlockSelect = (event) => this.selectByBlockId(event.detail?.blockId);
    this.section?.addEventListener('shopify:block:select', this.onBlockSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener('shopify:block:select', this.onBlockSelect);
  }

  select(tab) {
    if (!tab) return;

    const panelId = tab.getAttribute('aria-controls');

    this.tabs.forEach((item) => {
      const selected = item === tab;
      item.setAttribute('aria-selected', String(selected));
      item.tabIndex = selected ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.id !== panelId;
    });

    if (typeof tab.scrollIntoView === 'function') {
      tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }

  selectByBlockId(blockId) {
    if (!blockId) return;

    const panel = this.panels.find((item) => item.id.includes(blockId));
    const tab = this.tabs.find((item) => item.getAttribute('aria-controls') === panel?.id);
    this.select(tab);
  }

  onKeydown(event) {
    const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
    if (!keys.includes(event.key)) return;

    event.preventDefault();

    const current = this.tabs.indexOf(event.currentTarget);
    let next = current;

    if (event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
    if (event.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = this.tabs.length - 1;

    this.tabs[next].focus();
    this.select(this.tabs[next]);
  }
}

if (!customElements.get('faq-tabs')) {
  customElements.define('faq-tabs', FaqTabs);
}
